import { create } from 'zustand';

interface NotificationState {
  // Unread counts
  unreadMessages: number;
  setUnreadMessages: (count: number) => void;
  incrementUnreadMessages: () => void;
  decrementUnreadMessages: (count?: number) => void;

  // Toast notifications
  toasts: Toast[];
  addToast: (toast: Omit<Toast, 'id'>) => void;
  removeToast: (id: string) => void;
  clearToasts: () => void;
}

export interface Toast {
  id: string;
  type: 'success' | 'error' | 'warning' | 'info';
  title: string;
  message?: string;
  duration?: number;
}

let toastId = 0;

export const useNotificationStore = create<NotificationState>()((set) => ({
  // Unread messages
  unreadMessages: 0,
  setUnreadMessages: (count) => set({ unreadMessages: count }),
  incrementUnreadMessages: () =>
    set((state) => ({ unreadMessages: state.unreadMessages + 1 })),
  decrementUnreadMessages: (count = 1) =>
    set((state) => ({ unreadMessages: Math.max(0, state.unreadMessages - count) })),

  // Toasts
  toasts: [],
  addToast: (toast) =>
    set((state) => ({
      toasts: [
        ...state.toasts,
        {
          ...toast,
          id: `toast-${++toastId}`,
          duration: toast.duration ?? 5000,
        },
      ],
    })),
  removeToast: (id) =>
    set((state) => ({
      toasts: state.toasts.filter((t) => t.id !== id),
    })),
  clearToasts: () => set({ toasts: [] }),
}));
